import React, { useEffect, useState } from 'react';
import './style.scss';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Html from './Html';
import permissionModel from '../../../models/permisstion.model';
import environment from '../../../environment';
import ApiClient from '../../../methods/api/apiClient';
import RoleDetail from './../../../pages/Roles/Detail/index';

const Sidebar = ({ isOpen }) => {
  const user = useSelector((state) => state.user);
  const history = useNavigate();
  const [Permission, setPermissions] = useState({});
  const Permission_Check = JSON.parse(localStorage.getItem('permission'));

  useEffect(() => {
    if (!user?.id || (!user?._id && !localStorage.getItem('CRA_auth_token'))) {
      localStorage.removeItem('permission');
    }
  }, [user?.id]);

  // useEffect(() => {
  //   setPermissions(Permission_Check);
  // }, [Permission_Check]);
  const menus = {
    user: ['roles', 'users'],
    catalogue: ['types', 'categories', 'category/'],
    plan: ['features', 'plans'],
    api: ['bookingSystem', 'pos', 'reviews', 'accountingSystem'],
    geo: ['continents', 'countries', 'regions', 'cities'],
    dynamicPricing: ['dynamicprice'],
    skills: ['skills', 'skill-roles'],
    customer: ['customer', 'skill-roles'],
  };

  // console.log(items,"sldjfhsdyi")
  const ListItemLink = ({ to, type = 'link', disabled = false, ...rest }) => {
    let url = location.href;
    const host = location.host;
    url = url.split(host)[1];
    return (
      <>
        {type === 'link' ? (
          <li
            className={`nav-item ${url.includes(to) ? 'active' : ''} ${
              disabled ? 'disabled' : ''
            }`}
          >
            {/* {...rest} */}
            <Link to={to} {...rest} className="" />
          </li>
        ) : (
          <li
            className={`nav-item main ${url.includes(to) ? 'active' : ''}`}
            {...rest}
          ></li>
        )}
      </>
    );
  };

  const tabclass = (tab) => {
    let url = location.href;
    let value = false;
    menus[tab].map((itm) => {
      if (url.includes(itm)) value = true;
    });
    return value;
  };
  const isAllow = (url = '') => {
    if (user?.role == 'admin' || user?.roleDetail == 'admin') {
      return true;
    }
    if (
      user?.role == 'subadmin' ||
      (user?.roleDetail == 'subadmin' && url == 'subadmin_get')
    ) {
      return false;
    }

    if (url == 'readDashboard') {
      return true;
    }
    if (url == 'readPlan') {
      return true;
    }
    const itemss = JSON.parse(localStorage.getItem('items'));

    let arr = url.split(',');
    let value = false;
    arr.map((itm) => {
      if (Permission_Check?.[itm]) value = Permission_Check?.[itm];
    });
    return value;
  };

  const route = (p) => {
    history(p);
  };

  return (
    <>
      <Html
        route={route}
        user={user}
        tabclass={tabclass}
        urlAllow={isAllow}
        ListItemLink={ListItemLink}
        isOpen={isOpen}
      />
    </>
  );
};

export default Sidebar;
